import {atom} from 'jotai'

export const currentAccountClientTraderState = atom(null)
